module.exports = __webpack_public_path__ + "media/man3.4106bc37.wav";